// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"8b4fb1b7","530":"8b4fb1b7"}[chunkId] + ".chunk.css";
};